import { inject } from "@angular/core";
import { ROUTES } from "../const/routes";
import { Route } from "../models/route";
import { Base } from "./base";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { ApplicationInsightsService } from "../logger/application-insights-service";
import { AuthService } from "../services/auth.service";
import { LogService } from "../services/log.service";


export class BaseComponent extends Base {

  public document = inject(DOCUMENT)
  public router: Router = inject(Router)
  public location: Location = inject(Location)
  public logger: ApplicationInsightsService = inject(ApplicationInsightsService);
  public authService = inject(AuthService);
  public logService = inject(LogService);

  protected routes: Route[] = ROUTES

  constructor() {
    super();

    if (!window["beforeunloadAdded"]) {
      window.addEventListener("beforeunload", () => {
        try{
          this.authService.newLogoutFetch();
        }
        catch(e){
          
        }
      });

      window["beforeunloadAdded"] = true;
    }

    

  }



  public openInNewTab(url: string): void {
    var link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }



  
  public isClientOf(product: EProduct): boolean {
    const productName = this.getProductName(product);

    return this.getUser().products.includes(productName);
  }

  private getProductName(product: EProduct): string {
    switch (product) {
      case EProduct.Settings:
        return "Configurações";
    }
  }

}

export enum EProduct {
  Settings
}
